import React from "react";
import "./components.css";

function Footer() {
  return (
    <footer className="grid-bg-colour " style={{ paddingTop: 10 }}>
      <div className="container">
        <p className="m-0 text-center text-white">
          Copyright &copy; HQ Software 2025, v0.12
        </p>
      </div>
    </footer>
  );
}

export default Footer;
